import React from 'react';
import ReactCrop, {
  Crop,
  PercentCrop,
  convertToPixelCrop,
  convertToPercentCrop,
} from 'react-image-crop';

import 'react-image-crop/dist/ReactCrop.css';
import { centerAspectCrop } from './centerAcpectCrop';

function roundCrop(data: Crop): Crop {
  return {
    x: Math.round(data.x),
    y: Math.round(data.y),
    width: Math.round(data.width),
    height: Math.round(data.height),
    unit: data.unit,
  };
}

interface IProps {
  initialCrop: Crop;
  crop: Crop;
  setCrop: React.Dispatch<React.SetStateAction<Crop>>;
  handleCompleteCrop: (crop: Crop) => void;
  aspect?: number;
  imgSrc: string;
  imgRef: React.MutableRefObject<HTMLImageElement>;
}

export function MyCropper({
  crop,
  setCrop,
  handleCompleteCrop,
  aspect,
  imgRef,
  imgSrc,
  initialCrop,
}: IProps) {
  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    const { width, height, naturalWidth, naturalHeight } = e.currentTarget;
    if (initialCrop) {
      const pxToPercent = convertToPercentCrop(
        initialCrop,
        naturalWidth,
        naturalHeight
      );
      setCrop(pxToPercent);
    } else {
      setCrop(centerAspectCrop(width, height, aspect));
    }
  }

  const onCompleteCrop = (_: Crop, percentageCrop: PercentCrop) => {
    const naturalCrop = convertToPixelCrop(
      percentageCrop,
      imgRef.current?.naturalWidth,
      imgRef.current?.naturalHeight
    );
    handleCompleteCrop(roundCrop(naturalCrop));
  };

  console.log('ASPECT', aspect);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        backgroundColor: 'rgba(0,0,0, 0.5)',
      }}
    >
      {!!imgSrc && (
        <ReactCrop
          crop={crop}
          onChange={(_, percentageCrop) => setCrop(percentageCrop)}
          onComplete={onCompleteCrop}
          aspect={aspect}
        >
          <img
            ref={imgRef}
            alt='Crop me'
            src={imgSrc}
            onLoad={onImageLoad}
            style={{ maxWidth: '100%', maxHeight: '470px' }}
          />
        </ReactCrop>
      )}
    </div>
  );
}
